
import AppCustomLanguageSelect from "@/components/CustomLanguageSelect.vue";
import { SaleLayoutTotalLines } from "@/utils/sale-layouts/total-lines";
import AppStyleEditor from "@/components/layout-editor/StyleEditor.vue";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			selectedLanguage: "nl-be",
			vatStyleEditorOpen: false
		};
	},
	props: {
		lines: {
			type: Object as () => SaleLayoutTotalLines,
			required: true
		}
	},
	computed: {

	},
	methods: {

	},
	components: {
		AppCustomLanguageSelect,
		AppStyleEditor
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
